// This file is GENERATED by util/generate-api-client.js — DO NOT EDIT
import {
    Account,
    Action,
    AdvancedFirewallRule,
    ApiToken,
    ApiTokenCreateRequest,
    AvailableAdvancedServerFeatures,
    Balance,
    CardDetails,
    CardDetailsRequest,
    ChangePasswordRequest,
    ChangePaymentFrequencyRequest,
    Console,
    ContactDetails,
    ContactDetailsRequest,
    CreateAndPayForServerRequest,
    CreateAndPayForServerResult,
    CreateLoadBalancerRequest,
    CreateServerRequest,
    CreateVpcRequest,
    DataInterval,
    DataUsage,
    Domain,
    DomainAction,
    DomainOverview,
    DomainRecord,
    DomainRecordRequest,
    DomainRecordType,
    DomainRefreshRequest,
    DomainRegistrationPlan,
    DomainRegistrationSearchRequest,
    DomainRenewalPlan,
    DomainRenewalRequest,
    DomainRenewalResultResponse,
    DomainRequest,
    DomainTransferPlan,
    DomainTransferRequest,
    DomainTransferResultResponse,
    DomainTransferSearchRequest,
    DomainsRegistrationRequest,
    DomainsRegistrationResultResponse,
    EmailSubscriptions,
    EmailSubscriptionsRequest,
    FailoverIpsRequest,
    ForwardingRulesRequest,
    GetSiteServicesV2AccountManagementContactDetailsResult,
    GetSiteServicesV2AccountManagementSupportCodeResult,
    GetSiteServicesV2ApiTokenResult,
    GetSiteServicesV2AuthenticatorGenerateNewSecretResult,
    GetSiteServicesV2BillingDetailsCardDetailsResult,
    GetSiteServicesV2DomainManagementDomainNameResult,
    GetSiteServicesV2DomainManagementResult,
    GetSiteServicesV2DomainRegistrationActionsActionIdResult,
    GetSiteServicesV2DomainRegistrationDomainNameGetRenewalPlanResult,
    GetSiteServicesV2DomainRegistrationGetEnabledRegistrationPlansResult,
    GetSiteServicesV2FreshdeskSsoResult,
    GetSiteServicesV2PanelMigrationResult,
    GetSiteServicesV2PurchaseCompleteServerIdResult,
    GetSiteServicesV2ServersServerIdMonthlyCostResult,
    GetSiteServicesV2ServersServerIdValidRegionsResult,
    GetSiteServicesV2SignupEmailConfirmationRequiredResult,
    GetSiteServicesV2SubscriptionsResult,
    GetSiteServicesV2ZendeskMessagingJwtResult,
    GetSiteServicesV2ZendeskSsoResult,
    GetV2AccountKeysKeyIdResult,
    GetV2AccountKeysResult,
    GetV2AccountResult,
    GetV2ActionsActionIdResult,
    GetV2ActionsResult,
    GetV2CustomersMyBalanceResult,
    GetV2CustomersMyInvoicesInvoiceIdResult,
    GetV2CustomersMyInvoicesResult,
    GetV2CustomersMyUnpaidPaymentFailedInvoicesResult,
    GetV2DataUsagesCurrentResult,
    GetV2DataUsagesServerIdCurrentResult,
    GetV2DomainsDomainNameRecordsRecordIdResult,
    GetV2DomainsDomainNameRecordsResult,
    GetV2DomainsDomainNameResult,
    GetV2DomainsNameserversResult,
    GetV2DomainsResult,
    GetV2FailoverIpsServerIdAvailableResult,
    GetV2FailoverIpsServerIdResult,
    GetV2ImagesImageIdDownloadResult,
    GetV2ImagesImageIdOrSlugResult,
    GetV2ImagesResult,
    GetV2LoadBalancersAvailabilityResult,
    GetV2LoadBalancersLoadBalancerIdResult,
    GetV2LoadBalancersResult,
    GetV2RegionsResult,
    GetV2ReverseNamesIpv6Result,
    GetV2SamplesetsServerIdLatestResult,
    GetV2SamplesetsServerIdResult,
    GetV2ServersResult,
    GetV2ServersServerIdActionsActionIdResult,
    GetV2ServersServerIdActionsResult,
    GetV2ServersServerIdAdvancedFirewallRulesResult,
    GetV2ServersServerIdAvailableAdvancedFeaturesResult,
    GetV2ServersServerIdBackupsResult,
    GetV2ServersServerIdConsoleResult,
    GetV2ServersServerIdKernelsResult,
    GetV2ServersServerIdResult,
    GetV2ServersServerIdSnapshotsResult,
    GetV2ServersServerIdSoftwareResult,
    GetV2ServersServerIdThresholdAlertsResult,
    GetV2ServersServerIdUserDataResult,
    GetV2ServersThresholdAlertsResult,
    GetV2SizesPaymentFrequenciesResult,
    GetV2SizesResult,
    GetV2SizesServiceLevelsResult,
    GetV2SoftwareOperatingSystemOperatingSystemIdOrSlugResult,
    GetV2SoftwareResult,
    GetV2SoftwareSoftwareIdResult,
    GetV2VpcsResult,
    GetV2VpcsVpcIdMembersResult,
    GetV2VpcsVpcIdResult,
    GlueRecordsRequest,
    Image,
    ImageDownload,
    ImageQueryType,
    ImageRequest,
    Invoice,
    InvoicePaymentResult,
    InvoiceProcessingResult,
    Kernel,
    LicensedSoftware,
    LoadBalancer,
    LoadBalancerAvailabilityOption,
    LoginRequest,
    LoginResult,
    NameServersRequest,
    PasswordResetTokenResult,
    PatchV2VpcsVpcIdResult,
    PatchVpcRequest,
    PaypalCancellationRequest,
    PaypalCompletionResult,
    PaypalCreditDepositRequest,
    PaypalInvoicePaymentRequest,
    PaypalSuccessRequest,
    PhoneVerificationSetupResult,
    PostSiteServicesV2AccountManagementContactDetailsResult,
    PostSiteServicesV2AccountManagementSupportCodeRegenerateResult,
    PostSiteServicesV2AddCreditPaypalResult,
    PostSiteServicesV2ApiTokenCreateResult,
    PostSiteServicesV2ApiTokenIdRegenerateResult,
    PostSiteServicesV2ApiTokenIdUpdateResult,
    PostSiteServicesV2AuthLoginResult,
    PostSiteServicesV2AuthSendCodeViaSmsResult,
    PostSiteServicesV2AuthenticatorDisableAuthenticatorResult,
    PostSiteServicesV2AuthenticatorSetNewSecretResult,
    PostSiteServicesV2BillingDetailsCardDetailsResult,
    PostSiteServicesV2BillingDetailsSetupPaypalResult,
    PostSiteServicesV2CreateAndPayServersResult,
    PostSiteServicesV2DomainManagementDomainNameAuthCodeResult,
    PostSiteServicesV2DomainRegistrationDomainNameGetTransferPlanResult,
    PostSiteServicesV2DomainRegistrationDomainNameRenewDomainResult,
    PostSiteServicesV2DomainRegistrationDomainNameTransferDomainResult,
    PostSiteServicesV2DomainRegistrationGetRegistrationPlansResult,
    PostSiteServicesV2DomainRegistrationRegisterDomainsResult,
    PostSiteServicesV2InvoicePaymentInvoiceNumberPayWithCreditCardResult,
    PostSiteServicesV2InvoicePaymentInvoiceNumberPayWithPaypalResult,
    PostSiteServicesV2InvoicePaymentInvoiceNumberPayWithStoreCreditResult,
    PostSiteServicesV2InvoicePaymentRetryFailedResult,
    PostSiteServicesV2PasswordResetResult,
    PostSiteServicesV2PasswordResetVerifyPasswordResetTokenResult,
    PostSiteServicesV2PaypalCompletionCancelResult,
    PostSiteServicesV2PaypalCompletionSuccessResult,
    PostSiteServicesV2RegisterResult,
    PostSiteServicesV2SignupResult,
    PostSiteServicesV2SignupSendEmailConfirmationResult,
    PostSiteServicesV2SignupSetupPhoneVerificationResult,
    PostSiteServicesV2UploadBackupResult,
    PostV2AccountKeysResult,
    PostV2DomainsDomainNameRecordsResult,
    PostV2DomainsResult,
    PostV2FailoverIpsServerIdResult,
    PostV2LoadBalancersResult,
    PostV2ReverseNamesIpv6Result,
    PostV2ServersResult,
    PostV2ServersServerIdActionsResult,
    PostV2ServersServerIdBackupsResult,
    PostV2ServersServerIdPaymentFrequencyResult,
    PostV2VpcsResult,
    PrePaymentFrequencyOption,
    ProceedRequest,
    PurchaseComplete,
    PutSiteServicesV2DomainManagementDomainNameDisablePrivacyProtectionResult,
    PutSiteServicesV2DomainManagementDomainNameDisableRenewalRemindersResult,
    PutSiteServicesV2DomainManagementDomainNameEnablePrivacyProtectionResult,
    PutSiteServicesV2DomainManagementDomainNameEnableRenewalRemindersResult,
    PutSiteServicesV2DomainManagementDomainNameLockResult,
    PutSiteServicesV2DomainManagementDomainNameUnlockResult,
    PutSiteServicesV2DomainManagementDomainNameUpdateContactDetailsResult,
    PutSiteServicesV2DomainManagementDomainNameUpdateHostRegistryResult,
    PutSiteServicesV2DomainManagementDomainNameUpdateNameServersResult,
    PutSiteServicesV2PanelMigrationResult,
    PutSiteServicesV2SubscriptionsResult,
    PutV2AccountKeysKeyIdResult,
    PutV2DomainsDomainNameRecordsRecordIdResult,
    PutV2ImagesImageIdResult,
    PutV2LoadBalancersLoadBalancerIdResult,
    PutV2VpcsVpcIdResult,
    ReactMigrationStatus,
    Region,
    RegisterAccount,
    RegisterAccountRequest,
    RegisteredDomain,
    ResetPasswordUsingTokenRequest,
    ResourceType,
    ReverseNameserversRequest,
    SampleSet,
    SaveCardDetails,
    SendEmailCodeRequest,
    SendLoginCodeViaSmsRequest,
    SendPasswordResetRequest,
    Server,
    ServerAction,
    ServerCost,
    ServerIdsRequest,
    ServiceLevel,
    SetAuthenticatorSecretRequest,
    SetupPaypalAsPaymentMethodRequest,
    SetupPaypalResult,
    SetupPhoneVerificationRequest,
    SignupRequest,
    SignupResult,
    Size,
    Software,
    SshKey,
    SshKeyRequest,
    ThresholdAlert,
    UpdateDomainRecordRequest,
    UpdateLoadBalancerRequest,
    UpdatePanelMigrationStatusRequest,
    UpdateSshKeyRequest,
    UpdateVpcRequest,
    UploadImageRequest,
    UploadLocalImageRequest,
    VerificationSendResult,
    VerifyPasswordResetTokenRequest,
    Vpc,
    VpcMember,
} from './ApiModel';
import { PagedItem, PageSpec, pageSpecAsUrl, asPagedItems } from './helper/PagingHelper';
import WebApiClient from './WebApiClient';

function asQueryParams(params: Record<string, string | boolean | number | undefined>): string {
    const parts: string[] = [];
    for (const key of Object.keys(params)) {
        const val = params[key];
        if (val != undefined) {
            parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
        }
    }
    return parts.join('&');
}

// ── /v2/* ──────────────────────────────────────────────────────────────────

export async function getAccount(client: WebApiClient, cancellationToken?: AbortSignal): Promise<Account> {
    const result = await client.JsonGet<GetV2AccountResult>('/account', cancellationToken);
    return result.account;
}

export async function getAction(
    client: WebApiClient,
    action_id: number,
    cancellationToken?: AbortSignal
): Promise<Action> {
    const result = await client.JsonGet<GetV2ActionsActionIdResult>(`/actions/${action_id}`, cancellationToken);
    return result.action;
}

export async function getActions(
    client: WebApiClient,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<Action>> {
    const pageLink = pageSpecAsUrl(pageSpec, '/actions');
    const result = await client.JsonGet<GetV2ActionsResult>(pageLink, cancellationToken);
    return asPagedItems(result.actions, result);
}

export async function postActionProceed(client: WebApiClient, action_id: number, body: ProceedRequest): Promise<void> {
    await client.JsonRequest(`/actions/${action_id}/proceed`, 'POST', body);
}

export async function getCustomersMyBalance(client: WebApiClient, cancellationToken?: AbortSignal): Promise<Balance> {
    const result = await client.JsonGet<GetV2CustomersMyBalanceResult>('/customers/my/balance', cancellationToken);
    return result.balance;
}

export async function getCustomersMyInvoice(
    client: WebApiClient,
    invoice_id: number,
    cancellationToken?: AbortSignal
): Promise<Invoice> {
    const result = await client.JsonGet<GetV2CustomersMyInvoicesInvoiceIdResult>(
        `/customers/my/invoices/${invoice_id}`,
        cancellationToken
    );
    return result.invoice;
}

export async function getCustomersMyInvoices(
    client: WebApiClient,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<Invoice>> {
    const pageLink = pageSpecAsUrl(pageSpec, '/customers/my/invoices');
    const result = await client.JsonGet<GetV2CustomersMyInvoicesResult>(pageLink, cancellationToken);
    return asPagedItems(result.invoices, result);
}

export async function getCustomersMyUnpaidPaymentFailedInvoices(
    client: WebApiClient,
    cancellationToken?: AbortSignal
): Promise<Invoice[]> {
    const result = await client.JsonGet<GetV2CustomersMyUnpaidPaymentFailedInvoicesResult>(
        '/customers/my/unpaid-payment-failed-invoices',
        cancellationToken
    );
    return result.invoices;
}

export async function getDataUsageCurrent(
    client: WebApiClient,
    server_id: number,
    cancellationToken?: AbortSignal
): Promise<DataUsage> {
    const result = await client.JsonGet<GetV2DataUsagesServerIdCurrentResult>(
        `/data_usages/${server_id}/current`,
        cancellationToken
    );
    return result.data_usage;
}

export async function getDataUsagesCurrent(
    client: WebApiClient,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<DataUsage>> {
    const pageLink = pageSpecAsUrl(pageSpec, '/data_usages/current');
    const result = await client.JsonGet<GetV2DataUsagesCurrentResult>(pageLink, cancellationToken);
    return asPagedItems(result.data_usages, result);
}

export async function getDomainsNameservers(client: WebApiClient, cancellationToken?: AbortSignal): Promise<string[]> {
    const result = await client.JsonGet<GetV2DomainsNameserversResult>('/domains/nameservers', cancellationToken);
    return result.local_nameservers;
}

export async function postDomainsRefreshNameserverCache(
    client: WebApiClient,
    body: DomainRefreshRequest
): Promise<void> {
    await client.JsonRequest('/domains/refresh_nameserver_cache', 'POST', body);
}

export async function getDomains(
    client: WebApiClient,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<Domain>> {
    const pageLink = pageSpecAsUrl(pageSpec, '/domains');
    const result = await client.JsonGet<GetV2DomainsResult>(pageLink, cancellationToken);
    return asPagedItems(result.domains, result);
}

export async function postDomains(client: WebApiClient, body: DomainRequest): Promise<Domain> {
    const result = await client.JsonPost<PostV2DomainsResult>('/domains', body);
    return result.domain;
}

export async function getDomain(
    client: WebApiClient,
    domain_name: string,
    cancellationToken?: AbortSignal
): Promise<Domain> {
    const result = await client.JsonGet<GetV2DomainsDomainNameResult>(
        `/domains/${encodeURIComponent(domain_name)}`,
        cancellationToken
    );
    return result.domain;
}

export async function deleteDomain(client: WebApiClient, domain_name: string): Promise<void> {
    await client.JsonDelete(`/domains/${encodeURIComponent(domain_name)}`);
}

export async function getDomainRecords(
    client: WebApiClient,
    domain_name: string,
    type?: DomainRecordType,
    name?: string,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<DomainRecord>> {
    const params = asQueryParams({ type, name });
    const baseUrl = `/domains/${encodeURIComponent(domain_name)}/records${params ? `?${params}` : ''}`;
    const pageLink = pageSpecAsUrl(pageSpec, baseUrl);
    const result = await client.JsonGet<GetV2DomainsDomainNameRecordsResult>(pageLink, cancellationToken);
    return asPagedItems(result.domain_records, result);
}

export async function postDomainRecords(
    client: WebApiClient,
    domain_name: string,
    body: DomainRecordRequest
): Promise<DomainRecord> {
    const result = await client.JsonPost<PostV2DomainsDomainNameRecordsResult>(
        `/domains/${encodeURIComponent(domain_name)}/records`,
        body
    );
    return result.domain_record;
}

export async function getDomainRecord(
    client: WebApiClient,
    domain_name: string,
    record_id: number,
    cancellationToken?: AbortSignal
): Promise<DomainRecord> {
    const result = await client.JsonGet<GetV2DomainsDomainNameRecordsRecordIdResult>(
        `/domains/${encodeURIComponent(domain_name)}/records/${record_id}`,
        cancellationToken
    );
    return result.domain_record;
}

export async function putDomainRecord(
    client: WebApiClient,
    domain_name: string,
    record_id: number,
    body: UpdateDomainRecordRequest
): Promise<DomainRecord> {
    const result = await client.JsonPut<PutV2DomainsDomainNameRecordsRecordIdResult>(
        `/domains/${encodeURIComponent(domain_name)}/records/${record_id}`,
        body
    );
    return result.domain_record;
}

export async function deleteDomainRecord(client: WebApiClient, domain_name: string, record_id: number): Promise<void> {
    await client.JsonDelete(`/domains/${encodeURIComponent(domain_name)}/records/${record_id}`);
}

export async function getFailoverIp(
    client: WebApiClient,
    server_id: number,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<string>> {
    const pageLink = pageSpecAsUrl(pageSpec, `/failover_ips/${server_id}`);
    const result = await client.JsonGet<GetV2FailoverIpsServerIdResult>(pageLink, cancellationToken);
    return asPagedItems(result.failover_ips, result);
}

export async function postFailoverIp(
    client: WebApiClient,
    server_id: number,
    body: FailoverIpsRequest
): Promise<Action> {
    const result = await client.JsonPost<PostV2FailoverIpsServerIdResult>(`/failover_ips/${server_id}`, body);
    return result.action;
}

export async function getFailoverIpAvailable(
    client: WebApiClient,
    server_id: number,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<string>> {
    const pageLink = pageSpecAsUrl(pageSpec, `/failover_ips/${server_id}/available`);
    const result = await client.JsonGet<GetV2FailoverIpsServerIdAvailableResult>(pageLink, cancellationToken);
    return asPagedItems(result.failover_ips, result);
}

export async function getImages(
    client: WebApiClient,
    type?: ImageQueryType,
    private_?: boolean,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<Image>> {
    const params = asQueryParams({ type, private: private_ });
    const baseUrl = `/images${params ? `?${params}` : ''}`;
    const pageLink = pageSpecAsUrl(pageSpec, baseUrl);
    const result = await client.JsonGet<GetV2ImagesResult>(pageLink, cancellationToken);
    return asPagedItems(result.images, result);
}

export async function getImage(
    client: WebApiClient,
    image_id_or_slug: string,
    cancellationToken?: AbortSignal
): Promise<Image> {
    const result = await client.JsonGet<GetV2ImagesImageIdOrSlugResult>(
        `/images/${encodeURIComponent(image_id_or_slug)}`,
        cancellationToken
    );
    return result.image;
}

export async function putImage(client: WebApiClient, image_id: number, body: ImageRequest): Promise<Image> {
    const result = await client.JsonPut<PutV2ImagesImageIdResult>(`/images/${image_id}`, body);
    return result.image;
}

export async function getImageDownload(
    client: WebApiClient,
    image_id: number,
    cancellationToken?: AbortSignal
): Promise<ImageDownload> {
    const result = await client.JsonGet<GetV2ImagesImageIdDownloadResult>(
        `/images/${image_id}/download`,
        cancellationToken
    );
    return result.link;
}

export async function getAccountKey(
    client: WebApiClient,
    key_id: string,
    cancellationToken?: AbortSignal
): Promise<SshKey> {
    const result = await client.JsonGet<GetV2AccountKeysKeyIdResult>(
        `/account/keys/${encodeURIComponent(key_id)}`,
        cancellationToken
    );
    return result.ssh_key;
}

export async function putAccountKey(client: WebApiClient, key_id: string, body: UpdateSshKeyRequest): Promise<SshKey> {
    const result = await client.JsonPut<PutV2AccountKeysKeyIdResult>(
        `/account/keys/${encodeURIComponent(key_id)}`,
        body
    );
    return result.ssh_key;
}

export async function deleteAccountKey(client: WebApiClient, key_id: string): Promise<void> {
    await client.JsonDelete(`/account/keys/${encodeURIComponent(key_id)}`);
}

export async function getAccountKeys(
    client: WebApiClient,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<SshKey>> {
    const pageLink = pageSpecAsUrl(pageSpec, '/account/keys');
    const result = await client.JsonGet<GetV2AccountKeysResult>(pageLink, cancellationToken);
    return asPagedItems(result.ssh_keys, result);
}

export async function postAccountKeys(client: WebApiClient, body: SshKeyRequest): Promise<SshKey> {
    const result = await client.JsonPost<PostV2AccountKeysResult>('/account/keys', body);
    return result.ssh_key;
}

export async function getLoadBalancer(
    client: WebApiClient,
    load_balancer_id: number,
    cancellationToken?: AbortSignal
): Promise<LoadBalancer> {
    const result = await client.JsonGet<GetV2LoadBalancersLoadBalancerIdResult>(
        `/load_balancers/${load_balancer_id}`,
        cancellationToken
    );
    return result.load_balancer;
}

export async function putLoadBalancer(
    client: WebApiClient,
    load_balancer_id: number,
    body: UpdateLoadBalancerRequest
): Promise<LoadBalancer> {
    const result = await client.JsonPut<PutV2LoadBalancersLoadBalancerIdResult>(
        `/load_balancers/${load_balancer_id}`,
        body
    );
    return result.load_balancer;
}

export async function deleteLoadBalancer(client: WebApiClient, load_balancer_id: number): Promise<void> {
    await client.JsonDelete(`/load_balancers/${load_balancer_id}`);
}

export async function getLoadBalancers(
    client: WebApiClient,
    name?: string,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<LoadBalancer>> {
    const params = asQueryParams({ name });
    const baseUrl = `/load_balancers${params ? `?${params}` : ''}`;
    const pageLink = pageSpecAsUrl(pageSpec, baseUrl);
    const result = await client.JsonGet<GetV2LoadBalancersResult>(pageLink, cancellationToken);
    return asPagedItems(result.load_balancers, result);
}

export async function postLoadBalancers(client: WebApiClient, body: CreateLoadBalancerRequest): Promise<LoadBalancer> {
    const result = await client.JsonPost<PostV2LoadBalancersResult>('/load_balancers', body);
    return result.load_balancer;
}

export async function getLoadBalancersAvailability(
    client: WebApiClient,
    cancellationToken?: AbortSignal
): Promise<LoadBalancerAvailabilityOption[]> {
    const result = await client.JsonGet<GetV2LoadBalancersAvailabilityResult>(
        '/load_balancers/availability',
        cancellationToken
    );
    return result.load_balancer_availability_options;
}

export async function postLoadBalancerServers(
    client: WebApiClient,
    load_balancer_id: number,
    body: ServerIdsRequest
): Promise<void> {
    await client.JsonRequest(`/load_balancers/${load_balancer_id}/servers`, 'POST', body);
}

export async function deleteLoadBalancerServers(
    client: WebApiClient,
    load_balancer_id: number,
    body: ServerIdsRequest
): Promise<void> {
    await client.JsonRequest(`/load_balancers/${load_balancer_id}/servers`, 'DELETE', body);
}

export async function postLoadBalancerForwardingRules(
    client: WebApiClient,
    load_balancer_id: number,
    body: ForwardingRulesRequest
): Promise<void> {
    await client.JsonRequest(`/load_balancers/${load_balancer_id}/forwarding_rules`, 'POST', body);
}

export async function deleteLoadBalancerForwardingRules(
    client: WebApiClient,
    load_balancer_id: number,
    body: ForwardingRulesRequest
): Promise<void> {
    await client.JsonRequest(`/load_balancers/${load_balancer_id}/forwarding_rules`, 'DELETE', body);
}

export async function getRegions(
    client: WebApiClient,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<Region>> {
    const pageLink = pageSpecAsUrl(pageSpec, '/regions');
    const result = await client.JsonGet<GetV2RegionsResult>(pageLink, cancellationToken);
    return asPagedItems(result.regions, result);
}

export async function getReverseNamesIpv6(
    client: WebApiClient,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<string>> {
    const pageLink = pageSpecAsUrl(pageSpec, '/reverse_names/ipv6');
    const result = await client.JsonGet<GetV2ReverseNamesIpv6Result>(pageLink, cancellationToken);
    return asPagedItems(result.reverse_nameservers, result);
}

export async function postReverseNamesIpv6(client: WebApiClient, body: ReverseNameserversRequest): Promise<Action> {
    const result = await client.JsonPost<PostV2ReverseNamesIpv6Result>('/reverse_names/ipv6', body);
    return result.action;
}

export async function getSamplesetLatest(
    client: WebApiClient,
    server_id: number,
    data_interval?: DataInterval,
    cancellationToken?: AbortSignal
): Promise<SampleSet | null> {
    const params = asQueryParams({ data_interval });
    const url = `/samplesets/${server_id}/latest${params ? `?${params}` : ''}`;
    const result = await client.JsonGet<GetV2SamplesetsServerIdLatestResult>(url, cancellationToken);
    return result.sample_set ?? null;
}

export async function getSampleset(
    client: WebApiClient,
    server_id: number,
    data_interval?: DataInterval,
    start?: string,
    end?: string,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<SampleSet>> {
    const params = asQueryParams({ data_interval, start, end });
    const baseUrl = `/samplesets/${server_id}${params ? `?${params}` : ''}`;
    const pageLink = pageSpecAsUrl(pageSpec, baseUrl);
    const result = await client.JsonGet<GetV2SamplesetsServerIdResult>(pageLink, cancellationToken);
    return asPagedItems(result.sample_sets, result);
}

export async function getServerActions(
    client: WebApiClient,
    server_id: number,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<Action>> {
    const pageLink = pageSpecAsUrl(pageSpec, `/servers/${server_id}/actions`);
    const result = await client.JsonGet<GetV2ServersServerIdActionsResult>(pageLink, cancellationToken);
    return asPagedItems(result.actions, result);
}

export async function postServerActions(
    client: WebApiClient,
    server_id: number,
    body: ServerAction,
    cancellationToken?: AbortSignal
): Promise<Action | undefined> {
    const result = await client.JsonRequest<PostV2ServersServerIdActionsResult>(
        `/servers/${server_id}/actions`,
        'POST',
        body,
        cancellationToken
    );
    return result?.action;
}

export async function getServer(
    client: WebApiClient,
    server_id: number,
    cancellationToken?: AbortSignal
): Promise<Server> {
    const result = await client.JsonGet<GetV2ServersServerIdResult>(`/servers/${server_id}`, cancellationToken);
    return result.server;
}

export async function deleteServer(client: WebApiClient, server_id: number, reason?: string): Promise<void> {
    const params = asQueryParams({ reason });
    const url = `/servers/${server_id}${params ? `?${params}` : ''}`;
    await client.JsonDelete(url);
}

export async function getServers(
    client: WebApiClient,
    hostname?: string,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<Server>> {
    const params = asQueryParams({ hostname });
    const baseUrl = `/servers${params ? `?${params}` : ''}`;
    const pageLink = pageSpecAsUrl(pageSpec, baseUrl);
    const result = await client.JsonGet<GetV2ServersResult>(pageLink, cancellationToken);
    return asPagedItems(result.servers, result);
}

export async function postServers(client: WebApiClient, body: CreateServerRequest): Promise<Server> {
    const result = await client.JsonPost<PostV2ServersResult>('/servers', body);
    return result.server;
}

export async function getServerAction(
    client: WebApiClient,
    server_id: number,
    action_id: number,
    cancellationToken?: AbortSignal
): Promise<Action> {
    const result = await client.JsonGet<GetV2ServersServerIdActionsActionIdResult>(
        `/servers/${server_id}/actions/${action_id}`,
        cancellationToken
    );
    return result.action;
}

export async function getServerAdvancedFirewallRules(
    client: WebApiClient,
    server_id: number,
    cancellationToken?: AbortSignal
): Promise<AdvancedFirewallRule[]> {
    const result = await client.JsonGet<GetV2ServersServerIdAdvancedFirewallRulesResult>(
        `/servers/${server_id}/advanced_firewall_rules`,
        cancellationToken
    );
    return result.firewall_rules;
}

export async function getServerAvailableAdvancedFeatures(
    client: WebApiClient,
    server_id: number,
    cancellationToken?: AbortSignal
): Promise<AvailableAdvancedServerFeatures> {
    const result = await client.JsonGet<GetV2ServersServerIdAvailableAdvancedFeaturesResult>(
        `/servers/${server_id}/available_advanced_features`,
        cancellationToken
    );
    return result.available_advanced_server_features;
}

export async function getServerBackups(
    client: WebApiClient,
    server_id: number,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<Image>> {
    const pageLink = pageSpecAsUrl(pageSpec, `/servers/${server_id}/backups`);
    const result = await client.JsonGet<GetV2ServersServerIdBackupsResult>(pageLink, cancellationToken);
    return asPagedItems(result.backups, result);
}

export async function postServerBackups(
    client: WebApiClient,
    server_id: number,
    body: UploadImageRequest
): Promise<Action> {
    const result = await client.JsonPost<PostV2ServersServerIdBackupsResult>(`/servers/${server_id}/backups`, body);
    return result.action;
}

export async function getServerKernels(
    client: WebApiClient,
    server_id: number,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<Kernel>> {
    const pageLink = pageSpecAsUrl(pageSpec, `/servers/${server_id}/kernels`);
    const result = await client.JsonGet<GetV2ServersServerIdKernelsResult>(pageLink, cancellationToken);
    return asPagedItems(result.kernels, result);
}

export async function getServerSnapshots(
    client: WebApiClient,
    server_id: number,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<Image>> {
    const pageLink = pageSpecAsUrl(pageSpec, `/servers/${server_id}/snapshots`);
    const result = await client.JsonGet<GetV2ServersServerIdSnapshotsResult>(pageLink, cancellationToken);
    return asPagedItems(result.snapshots, result);
}

export async function getServerThresholdAlerts(
    client: WebApiClient,
    server_id: number,
    cancellationToken?: AbortSignal
): Promise<ThresholdAlert[]> {
    const result = await client.JsonGet<GetV2ServersServerIdThresholdAlertsResult>(
        `/servers/${server_id}/threshold_alerts`,
        cancellationToken
    );
    return result.threshold_alerts;
}

export async function getServersThresholdAlerts(
    client: WebApiClient,
    cancellationToken?: AbortSignal
): Promise<number[]> {
    const result = await client.JsonGet<GetV2ServersThresholdAlertsResult>(
        '/servers/threshold_alerts',
        cancellationToken
    );
    return result.server_ids;
}

export async function getServerSoftwares(
    client: WebApiClient,
    server_id: number,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<LicensedSoftware>> {
    const pageLink = pageSpecAsUrl(pageSpec, `/servers/${server_id}/software`);
    const result = await client.JsonGet<GetV2ServersServerIdSoftwareResult>(pageLink, cancellationToken);
    return asPagedItems(result.licensed_software, result);
}

export async function getServerUserData(
    client: WebApiClient,
    server_id: number,
    cancellationToken?: AbortSignal
): Promise<string | null> {
    const result = await client.JsonGet<GetV2ServersServerIdUserDataResult>(
        `/servers/${server_id}/user_data`,
        cancellationToken
    );
    return result.user_data ?? null;
}

export async function postServerPaymentFrequency(
    client: WebApiClient,
    server_id: number,
    body: ChangePaymentFrequencyRequest
): Promise<Server> {
    const result = await client.JsonPost<PostV2ServersServerIdPaymentFrequencyResult>(
        `/servers/${server_id}/payment_frequency`,
        body
    );
    return result.server;
}

export async function getServerConsole(
    client: WebApiClient,
    server_id: number,
    cancellationToken?: AbortSignal
): Promise<Console> {
    const result = await client.JsonGet<GetV2ServersServerIdConsoleResult>(
        `/servers/${server_id}/console`,
        cancellationToken
    );
    return result.console;
}

export async function getSizes(
    client: WebApiClient,
    server_id?: number,
    image?: string,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<Size>> {
    const params = asQueryParams({ server_id, image });
    const baseUrl = `/sizes${params ? `?${params}` : ''}`;
    const pageLink = pageSpecAsUrl(pageSpec, baseUrl);
    const result = await client.JsonGet<GetV2SizesResult>(pageLink, cancellationToken);
    return asPagedItems(result.sizes, result);
}

export async function getSizesPaymentFrequencies(
    client: WebApiClient,
    cancellationToken?: AbortSignal
): Promise<PrePaymentFrequencyOption[]> {
    const result = await client.JsonGet<GetV2SizesPaymentFrequenciesResult>(
        '/sizes/payment-frequencies',
        cancellationToken
    );
    return result.payment_frequency_options;
}

export async function getSizesServiceLevels(
    client: WebApiClient,
    cancellationToken?: AbortSignal
): Promise<ServiceLevel[]> {
    const result = await client.JsonGet<GetV2SizesServiceLevelsResult>('/sizes/service-levels', cancellationToken);
    return result.service_levels;
}

export async function getSoftware(
    client: WebApiClient,
    software_id: number,
    cancellationToken?: AbortSignal
): Promise<Software> {
    const result = await client.JsonGet<GetV2SoftwareSoftwareIdResult>(`/software/${software_id}`, cancellationToken);
    return result.software;
}

export async function getSoftwares(
    client: WebApiClient,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<Software>> {
    const pageLink = pageSpecAsUrl(pageSpec, '/software');
    const result = await client.JsonGet<GetV2SoftwareResult>(pageLink, cancellationToken);
    return asPagedItems(result.software, result);
}

export async function getSoftwareOperatingSystem(
    client: WebApiClient,
    operating_system_id_or_slug: string,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<Software>> {
    const pageLink = pageSpecAsUrl(
        pageSpec,
        `/software/operating_system/${encodeURIComponent(operating_system_id_or_slug)}`
    );
    const result = await client.JsonGet<GetV2SoftwareOperatingSystemOperatingSystemIdOrSlugResult>(
        pageLink,
        cancellationToken
    );
    return asPagedItems(result.software, result);
}

export async function getVpc(client: WebApiClient, vpc_id: number, cancellationToken?: AbortSignal): Promise<Vpc> {
    const result = await client.JsonGet<GetV2VpcsVpcIdResult>(`/vpcs/${vpc_id}`, cancellationToken);
    return result.vpc;
}

export async function putVpc(client: WebApiClient, vpc_id: number, body: UpdateVpcRequest): Promise<Vpc> {
    const result = await client.JsonPut<PutV2VpcsVpcIdResult>(`/vpcs/${vpc_id}`, body);
    return result.vpc;
}

export async function patchVpc(client: WebApiClient, vpc_id: number, body: PatchVpcRequest): Promise<Vpc> {
    const result = await client.JsonPatch<PatchV2VpcsVpcIdResult>(`/vpcs/${vpc_id}`, body);
    return result.vpc;
}

export async function deleteVpc(client: WebApiClient, vpc_id: number): Promise<void> {
    await client.JsonDelete(`/vpcs/${vpc_id}`);
}

export async function getVpcs(
    client: WebApiClient,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<Vpc>> {
    const pageLink = pageSpecAsUrl(pageSpec, '/vpcs');
    const result = await client.JsonGet<GetV2VpcsResult>(pageLink, cancellationToken);
    return asPagedItems(result.vpcs, result);
}

export async function postVpcs(client: WebApiClient, body: CreateVpcRequest): Promise<Vpc> {
    const result = await client.JsonPost<PostV2VpcsResult>('/vpcs', body);
    return result.vpc;
}

export async function getVpcMembers(
    client: WebApiClient,
    vpc_id: number,
    resource_type?: ResourceType,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<VpcMember>> {
    const params = asQueryParams({ resource_type });
    const baseUrl = `/vpcs/${vpc_id}/members${params ? `?${params}` : ''}`;
    const pageLink = pageSpecAsUrl(pageSpec, baseUrl);
    const result = await client.JsonGet<GetV2VpcsVpcIdMembersResult>(pageLink, cancellationToken);
    return asPagedItems(result.members, result);
}

// ── /site-services/v2/* ────────────────────────────────────────────────────

export async function getAccountManagementContactDetails(
    client: WebApiClient,
    cancellationToken?: AbortSignal
): Promise<ContactDetails> {
    const result = await client.JsonGet<GetSiteServicesV2AccountManagementContactDetailsResult>(
        '/account-management/contact-details',
        cancellationToken
    );
    return result.contact_details;
}

export async function postAccountManagementContactDetails(
    client: WebApiClient,
    body: ContactDetailsRequest
): Promise<ContactDetails> {
    const result = await client.JsonPost<PostSiteServicesV2AccountManagementContactDetailsResult>(
        '/account-management/contact-details',
        body
    );
    return result.contact_details;
}

export async function postAccountManagementChangePassword(
    client: WebApiClient,
    body: ChangePasswordRequest
): Promise<void> {
    await client.JsonRequest('/account-management/change-password', 'POST', body);
}

export async function getAccountManagementSupportCode(
    client: WebApiClient,
    cancellationToken?: AbortSignal
): Promise<string> {
    const result = await client.JsonGet<GetSiteServicesV2AccountManagementSupportCodeResult>(
        '/account-management/support-code',
        cancellationToken
    );
    return result.support_code;
}

export async function postAccountManagementSupportCodeRegenerate(client: WebApiClient): Promise<string> {
    const result = await client.JsonPost<PostSiteServicesV2AccountManagementSupportCodeRegenerateResult>(
        '/account-management/support-code/regenerate',
        null
    );
    return result.support_code;
}

export async function postActionPasswordResult(client: WebApiClient, actionId: number): Promise<void> {
    await client.JsonRequest(`/action-password-result/${actionId}`, 'POST', null);
}

export async function getApiTokens(client: WebApiClient, cancellationToken?: AbortSignal): Promise<ApiToken[]> {
    const result = await client.JsonGet<GetSiteServicesV2ApiTokenResult>('/api-token', cancellationToken);
    return result.api_tokens;
}

export async function postApiTokenCreate(client: WebApiClient, body: ApiTokenCreateRequest): Promise<ApiToken> {
    return await client.JsonPost<PostSiteServicesV2ApiTokenCreateResult>('/api-token/create', body);
}

export async function postApiTokenUpdate(
    client: WebApiClient,
    id: string,
    body: ApiTokenCreateRequest
): Promise<ApiToken> {
    return await client.JsonPost<PostSiteServicesV2ApiTokenIdUpdateResult>(
        `/api-token/${encodeURIComponent(id)}/update`,
        body
    );
}

export async function postApiTokenRegenerate(client: WebApiClient, id: string): Promise<ApiToken> {
    return await client.JsonPost<PostSiteServicesV2ApiTokenIdRegenerateResult>(
        `/api-token/${encodeURIComponent(id)}/regenerate`,
        null
    );
}

export async function deleteApiToken(client: WebApiClient, id: string): Promise<void> {
    await client.JsonRequest(`/api-token/${encodeURIComponent(id)}`, 'DELETE');
}

export async function postAuthLogin(client: WebApiClient, body: LoginRequest): Promise<LoginResult> {
    return await client.JsonPost<PostSiteServicesV2AuthLoginResult>('/auth/login', body);
}

export async function postAuthLogout(client: WebApiClient): Promise<void> {
    await client.JsonRequest('/auth/logout', 'POST');
}

export async function postAuthSendCodeViaSms(
    client: WebApiClient,
    body: SendLoginCodeViaSmsRequest
): Promise<VerificationSendResult> {
    const result = await client.JsonPost<PostSiteServicesV2AuthSendCodeViaSmsResult>('/auth/send-code-via-sms', body);
    return result.result;
}

export async function postAuthSendEmailCode(client: WebApiClient, body: SendEmailCodeRequest): Promise<void> {
    await client.JsonRequest('/auth/send-email-code', 'POST', body);
}

export async function getAuthenticatorGenerateNewSecret(
    client: WebApiClient,
    cancellationToken?: AbortSignal
): Promise<string> {
    const result = await client.JsonGet<GetSiteServicesV2AuthenticatorGenerateNewSecretResult>(
        '/authenticator/generate-new-secret',
        cancellationToken
    );
    return result.secret;
}

export async function postAuthenticatorSetNewSecret(
    client: WebApiClient,
    body: SetAuthenticatorSecretRequest
): Promise<Account> {
    const result = await client.JsonPost<PostSiteServicesV2AuthenticatorSetNewSecretResult>(
        '/authenticator/set-new-secret',
        body
    );
    return result.account;
}

export async function postAuthenticatorDisableAuthenticator(client: WebApiClient): Promise<Account> {
    const result = await client.JsonPost<PostSiteServicesV2AuthenticatorDisableAuthenticatorResult>(
        '/authenticator/disable-authenticator',
        null
    );
    return result.account;
}

export async function getBillingDetailsCardDetails(
    client: WebApiClient,
    cancellationToken?: AbortSignal
): Promise<CardDetails | null> {
    const result = await client.JsonGet<GetSiteServicesV2BillingDetailsCardDetailsResult>(
        '/billing-details/card-details',
        cancellationToken
    );
    return result.card_details ?? null;
}

export async function postBillingDetailsCardDetails(
    client: WebApiClient,
    body: CardDetailsRequest
): Promise<SaveCardDetails> {
    return await client.JsonPost<PostSiteServicesV2BillingDetailsCardDetailsResult>(
        '/billing-details/card-details',
        body
    );
}

export async function deleteBillingDetailsCardDetails(client: WebApiClient): Promise<void> {
    await client.JsonDelete('/billing-details/card-details');
}

export async function postBillingDetailsSetupPaypal(
    client: WebApiClient,
    body: SetupPaypalAsPaymentMethodRequest
): Promise<SetupPaypalResult> {
    return await client.JsonPost<PostSiteServicesV2BillingDetailsSetupPaypalResult>(
        '/billing-details/setup-paypal',
        body
    );
}

export async function postCreateAndPayServers(
    client: WebApiClient,
    body: CreateAndPayForServerRequest
): Promise<CreateAndPayForServerResult> {
    return await client.JsonPost<PostSiteServicesV2CreateAndPayServersResult>('/create-and-pay/servers', body);
}

export async function getDomainManagements(
    client: WebApiClient,
    pageSpec?: PageSpec,
    cancellationToken?: AbortSignal
): Promise<PagedItem<DomainOverview>> {
    const pageLink = pageSpecAsUrl(pageSpec, '/domain-management');
    const result = await client.JsonGet<GetSiteServicesV2DomainManagementResult>(pageLink, cancellationToken);
    return asPagedItems(result.domain_overviews, result);
}

export async function getDomainManagement(
    client: WebApiClient,
    domain_name: string,
    cancellationToken?: AbortSignal
): Promise<RegisteredDomain> {
    const result = await client.JsonGet<GetSiteServicesV2DomainManagementDomainNameResult>(
        `/domain-management/${encodeURIComponent(domain_name)}`,
        cancellationToken
    );
    return result.registered_domain;
}

export async function putDomainManagementLock(client: WebApiClient, domain_name: string): Promise<RegisteredDomain> {
    const result = await client.JsonPut<PutSiteServicesV2DomainManagementDomainNameLockResult>(
        `/domain-management/${encodeURIComponent(domain_name)}/lock`,
        null
    );
    return result.registered_domain;
}

export async function putDomainManagementUnlock(client: WebApiClient, domain_name: string): Promise<RegisteredDomain> {
    const result = await client.JsonPut<PutSiteServicesV2DomainManagementDomainNameUnlockResult>(
        `/domain-management/${encodeURIComponent(domain_name)}/unlock`,
        null
    );
    return result.registered_domain;
}

export async function putDomainManagementEnablePrivacyProtection(
    client: WebApiClient,
    domain_name: string
): Promise<RegisteredDomain> {
    const result = await client.JsonPut<PutSiteServicesV2DomainManagementDomainNameEnablePrivacyProtectionResult>(
        `/domain-management/${encodeURIComponent(domain_name)}/enable-privacy-protection`,
        null
    );
    return result.registered_domain;
}

export async function putDomainManagementDisablePrivacyProtection(
    client: WebApiClient,
    domain_name: string
): Promise<RegisteredDomain> {
    const result = await client.JsonPut<PutSiteServicesV2DomainManagementDomainNameDisablePrivacyProtectionResult>(
        `/domain-management/${encodeURIComponent(domain_name)}/disable-privacy-protection`,
        null
    );
    return result.registered_domain;
}

export async function putDomainManagementUpdateNameServers(
    client: WebApiClient,
    domain_name: string,
    body: NameServersRequest
): Promise<RegisteredDomain> {
    const result = await client.JsonPut<PutSiteServicesV2DomainManagementDomainNameUpdateNameServersResult>(
        `/domain-management/${encodeURIComponent(domain_name)}/update-name-servers`,
        body
    );
    return result.registered_domain;
}

export async function putDomainManagementUpdateHostRegistry(
    client: WebApiClient,
    domain_name: string,
    body: GlueRecordsRequest
): Promise<RegisteredDomain> {
    const result = await client.JsonPut<PutSiteServicesV2DomainManagementDomainNameUpdateHostRegistryResult>(
        `/domain-management/${encodeURIComponent(domain_name)}/update-host-registry`,
        body
    );
    return result.registered_domain;
}

export async function postDomainManagementAuthCode(
    client: WebApiClient,
    domain_name: string
): Promise<RegisteredDomain> {
    const result = await client.JsonPost<PostSiteServicesV2DomainManagementDomainNameAuthCodeResult>(
        `/domain-management/${encodeURIComponent(domain_name)}/auth-code`,
        null
    );
    return result.registered_domain;
}

export async function putDomainManagementDisableRenewalReminders(
    client: WebApiClient,
    domain_name: string
): Promise<RegisteredDomain> {
    const result = await client.JsonPut<PutSiteServicesV2DomainManagementDomainNameDisableRenewalRemindersResult>(
        `/domain-management/${encodeURIComponent(domain_name)}/disable-renewal-reminders`,
        null
    );
    return result.registered_domain;
}

export async function putDomainManagementEnableRenewalReminders(
    client: WebApiClient,
    domain_name: string
): Promise<RegisteredDomain> {
    const result = await client.JsonPut<PutSiteServicesV2DomainManagementDomainNameEnableRenewalRemindersResult>(
        `/domain-management/${encodeURIComponent(domain_name)}/enable-renewal-reminders`,
        null
    );
    return result.registered_domain;
}

export async function putDomainManagementUpdateContactDetails(
    client: WebApiClient,
    domain_name: string,
    body: ContactDetailsRequest
): Promise<RegisteredDomain> {
    const result = await client.JsonPut<PutSiteServicesV2DomainManagementDomainNameUpdateContactDetailsResult>(
        `/domain-management/${encodeURIComponent(domain_name)}/update-contact-details`,
        body
    );
    return result.registered_domain;
}

export async function postDomainRegistrationGetRegistrationPlans(
    client: WebApiClient,
    body: DomainRegistrationSearchRequest
): Promise<DomainRegistrationPlan[]> {
    const result = await client.JsonPost<PostSiteServicesV2DomainRegistrationGetRegistrationPlansResult>(
        '/domain-registration/get-registration-plans',
        body
    );
    return result.domain_registration_plans;
}

export async function getDomainRegistrationGetEnabledRegistrationPlans(
    client: WebApiClient,
    cancellationToken?: AbortSignal
): Promise<DomainRegistrationPlan[]> {
    const result = await client.JsonGet<GetSiteServicesV2DomainRegistrationGetEnabledRegistrationPlansResult>(
        '/domain-registration/get-enabled-registration-plans',
        cancellationToken
    );
    return result.domain_registration_plans;
}

export async function postDomainRegistrationRegisterDomains(
    client: WebApiClient,
    body: DomainsRegistrationRequest
): Promise<DomainsRegistrationResultResponse> {
    return await client.JsonPost<PostSiteServicesV2DomainRegistrationRegisterDomainsResult>(
        '/domain-registration/register-domains',
        body
    );
}

export async function getDomainRegistrationGetRenewalPlan(
    client: WebApiClient,
    domain_name: string,
    cancellationToken?: AbortSignal
): Promise<DomainRenewalPlan> {
    const result = await client.JsonGet<GetSiteServicesV2DomainRegistrationDomainNameGetRenewalPlanResult>(
        `/domain-registration/${encodeURIComponent(domain_name)}/get-renewal-plan`,
        cancellationToken
    );
    return result.domain_renewal_plan;
}

export async function getDomainRegistrationAction(
    client: WebApiClient,
    action_id: number,
    cancellationToken?: AbortSignal
): Promise<DomainAction> {
    return await client.JsonGet<GetSiteServicesV2DomainRegistrationActionsActionIdResult>(
        `/domain-registration/actions/${action_id}`,
        cancellationToken
    );
}

export async function postDomainRegistrationRenewDomain(
    client: WebApiClient,
    domain_name: string,
    body: DomainRenewalRequest
): Promise<DomainRenewalResultResponse> {
    return await client.JsonPost<PostSiteServicesV2DomainRegistrationDomainNameRenewDomainResult>(
        `/domain-registration/${encodeURIComponent(domain_name)}/renew-domain`,
        body
    );
}

export async function postDomainRegistrationGetTransferPlan(
    client: WebApiClient,
    domain_name: string,
    body: DomainTransferSearchRequest
): Promise<DomainTransferPlan> {
    const result = await client.JsonPost<PostSiteServicesV2DomainRegistrationDomainNameGetTransferPlanResult>(
        `/domain-registration/${encodeURIComponent(domain_name)}/get-transfer-plan`,
        body
    );
    return result.domain_transfer_plan;
}

export async function postDomainRegistrationTransferDomain(
    client: WebApiClient,
    domain_name: string,
    body: DomainTransferRequest
): Promise<DomainTransferResultResponse> {
    return await client.JsonPost<PostSiteServicesV2DomainRegistrationDomainNameTransferDomainResult>(
        `/domain-registration/${encodeURIComponent(domain_name)}/transfer-domain`,
        body
    );
}

export async function getSubscriptions(
    client: WebApiClient,
    cancellationToken?: AbortSignal
): Promise<EmailSubscriptions> {
    const result = await client.JsonGet<GetSiteServicesV2SubscriptionsResult>('/subscriptions', cancellationToken);
    return result.email_subscriptions;
}

export async function putSubscriptions(
    client: WebApiClient,
    body: EmailSubscriptionsRequest
): Promise<EmailSubscriptions> {
    const result = await client.JsonPut<PutSiteServicesV2SubscriptionsResult>('/subscriptions', body);
    return result.email_subscriptions;
}

export async function getFreshdeskSso(
    client: WebApiClient,
    redirect_to?: string,
    host_url?: string,
    cancellationToken?: AbortSignal
): Promise<string> {
    const params = asQueryParams({ redirect_to, host_url });
    const url = `/freshdesk/sso${params ? `?${params}` : ''}`;
    const result = await client.JsonGet<GetSiteServicesV2FreshdeskSsoResult>(url, cancellationToken);
    return result.url;
}

export async function getServerValidRegions(
    client: WebApiClient,
    server_id: number,
    cancellationToken?: AbortSignal
): Promise<Region[]> {
    const result = await client.JsonGet<GetSiteServicesV2ServersServerIdValidRegionsResult>(
        `/servers/${server_id}/valid_regions`,
        cancellationToken
    );
    return result.regions;
}

export async function getAuthKeepAlive(client: WebApiClient): Promise<void> {
    await client.JsonRequest('/auth/keep-alive', 'GET');
}

export async function getPanelMigration(
    client: WebApiClient,
    cancellationToken?: AbortSignal
): Promise<ReactMigrationStatus> {
    const result = await client.JsonGet<GetSiteServicesV2PanelMigrationResult>('/panel_migration', cancellationToken);
    return result.migration_status;
}

export async function putPanelMigration(
    client: WebApiClient,
    body: UpdatePanelMigrationStatusRequest
): Promise<ReactMigrationStatus> {
    const result = await client.JsonPut<PutSiteServicesV2PanelMigrationResult>('/panel_migration', body);
    return result.migration_status;
}

export async function postPasswordResetSendResetToken(
    client: WebApiClient,
    body: SendPasswordResetRequest
): Promise<void> {
    await client.JsonRequest('/password-reset/send-reset-token', 'POST', body);
}

export async function postPasswordResetVerifyPasswordResetToken(
    client: WebApiClient,
    body: VerifyPasswordResetTokenRequest
): Promise<PasswordResetTokenResult> {
    return await client.JsonPost<PostSiteServicesV2PasswordResetVerifyPasswordResetTokenResult>(
        '/password-reset/verify-password-reset-token',
        body
    );
}

export async function postPasswordReset(
    client: WebApiClient,
    body: ResetPasswordUsingTokenRequest
): Promise<PasswordResetTokenResult> {
    return await client.JsonPost<PostSiteServicesV2PasswordResetResult>('/password-reset', body);
}

export async function postInvoicePaymentPayWithStoreCredit(
    client: WebApiClient,
    invoiceNumber: number
): Promise<InvoicePaymentResult> {
    return await client.JsonPost<PostSiteServicesV2InvoicePaymentInvoiceNumberPayWithStoreCreditResult>(
        `/invoice-payment/${invoiceNumber}/pay-with-store-credit`,
        null
    );
}

export async function postInvoicePaymentPayWithCreditCard(
    client: WebApiClient,
    invoiceNumber: number
): Promise<InvoicePaymentResult> {
    return await client.JsonPost<PostSiteServicesV2InvoicePaymentInvoiceNumberPayWithCreditCardResult>(
        `/invoice-payment/${invoiceNumber}/pay-with-credit-card`,
        null
    );
}

export async function postInvoicePaymentPayWithPaypal(
    client: WebApiClient,
    invoiceNumber: number,
    body: PaypalInvoicePaymentRequest
): Promise<string | null> {
    const result = await client.JsonPost<PostSiteServicesV2InvoicePaymentInvoiceNumberPayWithPaypalResult>(
        `/invoice-payment/${invoiceNumber}/pay-with-paypal`,
        body
    );
    return result.authorization_url ?? null;
}

export async function postAddCreditPaypal(
    client: WebApiClient,
    body: PaypalCreditDepositRequest
): Promise<string | null> {
    const result = await client.JsonPost<PostSiteServicesV2AddCreditPaypalResult>('/add-credit/paypal', body);
    return result.authorization_url ?? null;
}

export async function postInvoicePaymentRetryFailed(client: WebApiClient): Promise<InvoiceProcessingResult> {
    const result = await client.JsonPost<PostSiteServicesV2InvoicePaymentRetryFailedResult>(
        '/invoice-payment/retry-failed',
        null
    );
    return result.result;
}

export async function postPaypalCompletionSuccess(
    client: WebApiClient,
    body: PaypalSuccessRequest
): Promise<PaypalCompletionResult> {
    return await client.JsonPost<PostSiteServicesV2PaypalCompletionSuccessResult>('/paypal-completion/success', body);
}

export async function postPaypalCompletionCancel(
    client: WebApiClient,
    body: PaypalCancellationRequest
): Promise<PaypalCompletionResult> {
    return await client.JsonPost<PostSiteServicesV2PaypalCompletionCancelResult>('/paypal-completion/cancel', body);
}

export async function getPurchaseComplete(
    client: WebApiClient,
    server_id: number,
    cancellationToken?: AbortSignal
): Promise<PurchaseComplete> {
    return await client.JsonGet<GetSiteServicesV2PurchaseCompleteServerIdResult>(
        `/purchase-complete/${server_id}`,
        cancellationToken
    );
}

export async function postRegister(client: WebApiClient, body: RegisterAccountRequest): Promise<RegisterAccount> {
    return await client.JsonPost<PostSiteServicesV2RegisterResult>('/register', body);
}

export async function postRegisterConfirmEmail(client: WebApiClient, body: string): Promise<void> {
    await client.JsonRequest('/register/confirm-email', 'POST', body);
}

export async function getServerMonthlyCost(
    client: WebApiClient,
    server_id: number,
    cancellationToken?: AbortSignal
): Promise<ServerCost> {
    const result = await client.JsonGet<GetSiteServicesV2ServersServerIdMonthlyCostResult>(
        `/servers/${server_id}/monthly_cost`,
        cancellationToken
    );
    return result.server_cost;
}

export async function getSignupEmailConfirmationRequired(
    client: WebApiClient,
    cancellationToken?: AbortSignal
): Promise<boolean> {
    return await client.JsonGet<GetSiteServicesV2SignupEmailConfirmationRequiredResult>(
        '/signup/email-confirmation-required',
        cancellationToken
    );
}

export async function postSignupSendEmailConfirmation(client: WebApiClient): Promise<boolean> {
    return await client.JsonPost<PostSiteServicesV2SignupSendEmailConfirmationResult>(
        '/signup/send-email-confirmation',
        null
    );
}

export async function postSignupSetupPhoneVerification(
    client: WebApiClient,
    body: SetupPhoneVerificationRequest
): Promise<PhoneVerificationSetupResult> {
    return await client.JsonPost<PostSiteServicesV2SignupSetupPhoneVerificationResult>(
        '/signup/setup-phone-verification',
        body
    );
}

export async function postSignupValidateServer(client: WebApiClient, body: CreateServerRequest): Promise<void> {
    await client.JsonRequest('/signup/validate-server', 'POST', body);
}

export async function postSignup(client: WebApiClient, body: SignupRequest): Promise<SignupResult> {
    return await client.JsonPost<PostSiteServicesV2SignupResult>('/signup', body);
}

export async function postUploadBackups(client: WebApiClient, body: UploadLocalImageRequest): Promise<Action> {
    const result = await client.JsonPost<PostSiteServicesV2UploadBackupResult>('/upload-backup', body);
    return result.action;
}

export async function postUploadBackup(client: WebApiClient, actionId: number): Promise<void> {
    await client.JsonRequest(`/upload-backup/${actionId}`, 'POST', null);
}

export async function getZendeskMessagingJwt(client: WebApiClient, cancellationToken?: AbortSignal): Promise<string> {
    const result = await client.JsonGet<GetSiteServicesV2ZendeskMessagingJwtResult>(
        '/zendesk/messaging-jwt',
        cancellationToken
    );
    return result.jwt;
}

export async function getZendeskSso(
    client: WebApiClient,
    return_to?: string,
    cancellationToken?: AbortSignal
): Promise<string> {
    const params = asQueryParams({ return_to });
    const url = `/zendesk/sso${params ? `?${params}` : ''}`;
    const result = await client.JsonGet<GetSiteServicesV2ZendeskSsoResult>(url, cancellationToken);
    return result.url;
}
